import CustomImage from '../custom-image/CustomImage';
import CardWrapper from './CardWrapper';

export default function CardNews({ card, colorIndex, category, isEvent }) {
  if (!card) return null;

  // console.log(card?.taxonomies?.[0]?.name);

  // Events reuse this card, so callers that know the post type pass `isEvent`.
  // Where they don't (the generic CardGrid map), fall back to the date/time
  // fields, which only the events CPT supplies.
  const eventCard = isEvent ?? !!(card.eventDate || card.eventTime);

  return (
    <CardWrapper
      link={card?.link}
      className={`cardNews${eventCard ? ' cardNews--event' : ''}`}
      colorIndex={colorIndex}
    >
      {/* {card.label && (
        <div className="cardNews-tag">
          <p>{card.label}</p>
        </div>
      )} */}
      {card.eventDate && (
        <div className="cardNews-tag headingStrong step--1">
          <p>{card.eventDate}</p>
        </div>
      )}
      {card?.taxonomies?.[0]?.name && (
        <div className="cardNews-tag h7">
          <p>{card.taxonomies[0].name}</p>
        </div>
      )}
      <div className="cardNews-media">
        <CustomImage
          image={card.image}
          fill={true}
          sizes={'(max-width: 768px) 100vw, 33vw'}
          // parallax
        />
      </div>
      <div className="cardNews-text">
        {/* {card.label && (
          <p className="cardNews-subheading text--size-xs">{card.label}</p>
        )}
         */}
        {card.eventTime && (
          <p className="cardNews-subheading text--size-xs headingStrong">
            {card.eventTime}
          </p>
        )}
        {/* {card.label && (
          <p className="cardNews-subheading text--size-xs headingStrong">
            {card.label}
          </p>
        )} */}

        {card.heading && (
          <h3
            className="cardNews-heading h5"
            dangerouslySetInnerHTML={{ __html: card.heading }}
          />
        )}
      </div>
    </CardWrapper>
  );
}
